/**
 * 피드 링크 파라미터의 **주소 처리**만 둔다 — 브라우저(`useStripGlCountryParam`)도 import 한다.
 * flag 조회처럼 서버 전용인 것은 `gl-country-param.ts` 에 있다(클라이언트 번들로 딸려 가지 않게).
 */
export const GL_COUNTRY_PARAM = "glCountry";
/** 읽지는 않지만 주소에서 함께 지운다(`stripGlParams`). */
export const GL_CURRENCY_PARAM = "glCurrency";

/**
 * 주소에서 두 파라미터를 뺀 query. 둘 다 없으면 `null`(바꿀 것 없음).
 *
 * 들어온 뒤 주소에 남아 있으면 **사용자가 나중에 고른 국가를 되돌린다** — 국가 선택 창(`setLocale`)이
 * query 를 그대로 둔 채 주소를 바꾸고 GE 국가가 걸린 변경이면 새로고침하므로, 그 요청(또는 그 주소의 다음
 * 전체 로드)에서 미들웨어가 `bh_ccode` 를 링크 국가로 다시 덮는다.
 * 링크 공유·즐겨찾기도 받는 사람의 국가를 바꾼다. 쿠키는 이미 남았으니 지워도 국가는 유지된다.
 */
export function stripGlParams<T extends Record<string, unknown>>(
  query: T,
): T | null {
  if (!(GL_COUNTRY_PARAM in query) && !(GL_CURRENCY_PARAM in query)) {
    return null;
  }
  const rest = { ...query };
  delete rest[GL_COUNTRY_PARAM];
  delete rest[GL_CURRENCY_PARAM];
  return rest;
}
